import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

var _Circle, _Circle2, _Circle3;

function Circle() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.circle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.innerCircle
  }));
}

function PendingAnimation(props) {
  const {
    className,
    inheritColor
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.pendingAnimation, inheritColor && styles.inheritColor, className)
  }, _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, null)), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, null)), _Circle3 || (_Circle3 = /*#__PURE__*/React.createElement(Circle, null)));
}

var PendingAnimation$1 = genericMemo(PendingAnimation);

export { PendingAnimation$1 as default };
//# sourceMappingURL=index.js.map
